// extracted by mini-css-extract-plugin
export default {"benefitWrapper":"Benefit-module__benefitWrapper--UBDu9","benefitText":"Benefit-module__benefitText--cbFWF"};